export const parseQueryString = (queryStr: string) => {
  const query = decodeURI((queryStr || "").trim().replace(/\?/, ""));

  if (query === "") {
    return {};
  }

  const parts = query.split(/[;&]/);

  return parts.reduce<Record<string, any>>((seq, str) => {
    const subParts = str.split("=");
    const len = subParts.length;
    const key = subParts[0];

    if (key) {
      seq[key] = len > 1 ? decodeURIComponent(subParts[1]) : "";
    }

    return seq;
  }, {});
};
